import locationInput from './locationInput.json'

const enAU = {
  locationInput,
}

export default enAU
